import { render } from "./BusinessDynamic.vue?vue&type=template&id=6d65a94e&scoped=true"
import script from "./BusinessDynamic.vue?vue&type=script&lang=js"
export * from "./BusinessDynamic.vue?vue&type=script&lang=js"

import "./BusinessDynamic.vue?vue&type=style&index=0&id=6d65a94e&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d65a94e"]])

export default __exports__